/**
 * @file Notice API
 */

import axios from 'axios'

export default {
  // API:13
  async getNotices(page, per_page) {
    const { data } = await axios.get(`users/notices?page=${page}&per_page=${per_page}`)

    return data
  },
  // API:14
  async getNotice(notice_id) {
    const { data } = await axios.get(`users/notices/${notice_id}`)

    return data
  },
}
